/**
 * Handles the removal of review items from the review form.
 * When an item is removed, it also triggers a search update to ensure
 * the removed item becomes available in the search results again.
 */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item"];

  /**
   * Removes a review item from the form and updates the search state.
   * This method is called when a user clicks the remove button on a review item.
   * It ensures the removed item becomes available in the search results again
   * by triggering a search update without expanding the results container.
   */
  removeItem() {
    this.itemTarget.remove();
    // Update all review-item-search controllers
    // (spa/barber venues may have multiple search
    // controllers for items + practitioners)
    const searchControllers =
      document.querySelectorAll(
        '[data-controller="review-item-search"]'
      );
    searchControllers.forEach((el) => {
      const controller =
        this.application
          .getControllerForElementAndIdentifier(
            el, "review-item-search"
          );
      controller?.searchWithoutExpandingResults();
    });
  }
}
